module.exports = __webpack_public_path__ + "img/rv-dump-stations.c64c8142.svg";